import { render, staticRenderFns } from "./Investering.vue?vue&type=template&id=8d20ae64&"
import script from "./Investering.vue?vue&type=script&lang=js&"
export * from "./Investering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports